import React from "react";

export default function ReturnToHomepage() {
  return (
    <p className="text-center mt-4">
      <a href="/" className="btn btn-secondary">
        Return to the Keepsight homepage
      </a>
    </p>
  );
}
